export const SORT_FIELD_KEY = 'sort.field';
export const SORT_DIRECTION_KEY = 'sort.direction';
